import React, { useState } from 'react';

const defaultValue = {
  servicos: [],
  servicoAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  page: 0,
  size: 15,
  modal: '',
  search: '',
  sort: 'descricao,ASC',
  filtroAvancado: {}
};

export const ServicoContext = React.createContext({});

export const ServicoProvider = (props) => {
  return (
    <ServicoContext.Provider
      value={{
        servicos: useState(defaultValue.servicos),
        servicoAtual: useState(defaultValue.servicoAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        sort: useState(defaultValue.sort),
        filtroAvancado: useState(defaultValue.filtroAvancado),
      }}
    >
      {props.children}
    </ServicoContext.Provider>
  );
};

export const ServicoConsumer = ServicoContext.Consumer;
